import { graphql, readInlineData, FragmentRef } from 'react-relay/legacy';

export const PROMO_CODE_TRADE_FIRST_WELCOME = 'TRADE1STWELCOME';

const userFragment = graphql`
    fragment expiringPromoMessageHelpers_user on User @inline {
        expiringPromotion {
            daysRelativeToExpiration(truncate: false)
            promotionMeta {
                urgencyMessagingDisplay
                urgencyMessagingDaysBeforeExpiration
            }
        }
    }
`;

import { sharedMessageHelpers_user } from './__generated__/sharedMessageHelpers_user.graphql';
import { expiringPromoMessageHelpers_user } from './__generated__/expiringPromoMessageHelpers_user.graphql';

type UserFragmentRef = expiringPromoMessageHelpers_user | sharedMessageHelpers_user;

export const shouldShowExpiringPromo = (user: FragmentRef<UserFragmentRef>): boolean => {
    const userData = readInlineData<UserFragmentRef>(userFragment, user);
    // @ts-ignore come back to this before merging, only ignoring for UAT
    const promoData = userData?.expiringPromotion || userData?.activePromotion || {};
    const { promotionMeta } = promoData;
    const { daysRelativeToExpiration } = promoData;
    const promoDaysToExpire = Number(daysRelativeToExpiration);
    const urgencyMessagingDisplay = !!promotionMeta?.urgencyMessagingDisplay;
    const urgencyMessagingDaysBeforeExpiration =
        promotionMeta?.urgencyMessagingDaysBeforeExpiration || 0;
    return (
        urgencyMessagingDisplay &&
        promoDaysToExpire >= 0 &&
        promoDaysToExpire <= urgencyMessagingDaysBeforeExpiration
    );
};
